import React, { useState, useEffect } from "react";
import "../Styles/Navber.css";
import logo from "../Images/Jayraj_logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faBars,
  faXmark,
  faUser,
  faCaretDown,
  faAward,
  faHome,
  faHotel,
  faBus,
  faUmbrellaBeach,
  faMapMarkedAlt,
  faSignInAlt,
  faSignOutAlt,
  faUsers,
  faSuitcaseRolling,
  faClock,
  faImages,
  faPlane,
  faPen,
  faHeart,
  faRing,
  faCar
} from "@fortawesome/free-solid-svg-icons";
import api from "../Api.js";
import heart_logo from "../Images/heart_logo.png";
import heart_logo1 from "../Images/heart_logo1.png";
import home_icon from "../Images/home-icon.png";
import hotel_icon from "../Images/hotel_icon.png";
import itinerary_icon from "../Images/itinerary_icon.png";
import activity_icon from "../Images/activity_icon.png";
import tour_icon from "../Images/tours_icon.png";

const TOUR_MENU = [
  { to: "/tour/plantour", icon: faMapMarkedAlt, label: "Plan Tour" },
  { to: "/tour/grouptour", icon: faUsers, label: "Group Tour" },
  { to: "/tour/packagetour", icon: faSuitcaseRolling, label: "Package Tour" },
  { to: "/tour/weekendtour", icon: faClock, label: "Weekend Tour" },
];

function Navber() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [token, setToken] = useState(null);
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    setToken(localStorage.getItem("accessToken"));
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("customer");
    setToken(null);
    navigate("/signup");
  };

  useEffect(() => {
    if (!token) return;

    const getProfileData = async () => {
      try {
        const res = await api.get("/profile", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setProfile(res?.data?.customer);
      } catch (err) {
        console.log(err);
      }
    };

    getProfileData();
  }, [token]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className="jr-navbar">
        {/* LOGO */}
        <div className="jr-logo" onClick={() => navigate("/")}>
          <img src={logo} alt="Jayraj Group" />
        </div>

        {/* ================= DESKTOP MENU ================= */}
        <ul className="jr-nav-links" style={{ marginBottom: "0px" }}>
          <li>
            <NavLink to="/">
              <img src={home_icon} alt="Home Logo" width="20" height="16" /> Home
            </NavLink>
          </li>

          <li className="jr-dropdown" style={{ marginLeft: "10px" }}>
            <span>
              <img src={tour_icon} alt="Tours Logo" width="20" height="19" /> Tours{" "}
              <FontAwesomeIcon icon={faCaretDown} />
            </span>
            <div className="jr-dropdown-menu">
              {TOUR_MENU.map((item) => (
                <NavLink key={item.to} to={item.to}>
                  <FontAwesomeIcon icon={item.icon} /> {item.label}
                </NavLink>
              ))}
            </div>
          </li>

          <li>
            <NavLink to="/hotels">
              <img src={hotel_icon} alt="Hotel Logo" width="20" height="16" /> Hotel
            </NavLink>
          </li>
          <li>
            <NavLink to="/destination-wedding">
              <img src={heart_logo} alt="Heart Logo" width="20" height="20" /> Destination Wedding
            </NavLink>
          </li>
          <li>
            <NavLink to="/honeymoon">
              <img src={heart_logo1} alt="Heart Logo" width="20" height="20" /> Honeymoon
            </NavLink>
          </li>

          <li>
            <NavLink to="/activities">
              <img src={activity_icon} alt="Activity Logo" width="20" height="20" /> Activity
            </NavLink>
          </li>

          <li>
            <NavLink to="/cab" onClick={closeMenu}>
              <FontAwesomeIcon icon={faCar} /> Cab
            </NavLink>
          </li>

          <li>
            <NavLink to="/franchise" className="jr-franchise-btn" style={{color:"black"}}>
              + Franchise
            </NavLink>
          </li>
        </ul>

        {/* ================= RIGHT ACTIONS ================= */}
        <div className="jr-actions">
          {!token ? (
            <button onClick={() => navigate("/signup")} className="jr-login-btn">
              <FontAwesomeIcon icon={faUser} /> Login
            </button>
          ) : (
            <div className="jr-profile">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="jr-profile-icon" onClick={() => navigate("/profile")}>
                  {profile?.photo ? (
                    <img src={profile.photo} alt="Profile" className="jr-profile-img" />
                  ) : (
                    <FontAwesomeIcon icon={faUser} />
                  )}
                </div>
                <FontAwesomeIcon icon={faCaretDown} />
              </div>

              <div className="jr-profile-menu">
                <span onClick={() => navigate("/profile")}>
                  <FontAwesomeIcon icon={faUser} /> Profile
                </span>
                <span onClick={handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                </span>
              </div>
            </div>
          )}

          <FontAwesomeIcon
            icon={faBars}
            className="jr-menu-icon"
            onClick={() => setMenuOpen(true)}
          />
        </div>
      </nav>

      {/* ================= MOBILE MENU (OUTSIDE NAVBAR) ================= */}
      <ul className={`jr-nav-mobile ${menuOpen ? "open" : ""}`}>
        <FontAwesomeIcon
          icon={faXmark}
          className="jr-close-icon"
          onClick={closeMenu}
        />

        <li>
          <NavLink to="/" onClick={closeMenu}>
            <FontAwesomeIcon icon={faHome} /> Home
          </NavLink>
        </li>

        {TOUR_MENU.map((item) => (
          <li key={item.to}>
            <NavLink to={item.to} onClick={closeMenu}>
              <FontAwesomeIcon icon={item.icon} /> {item.label}
            </NavLink>
          </li>
        ))}

        <li>
          <NavLink to="/hotels" onClick={closeMenu}>
            <FontAwesomeIcon icon={faHotel} /> Hotel
          </NavLink>
        </li>
        <li>
          <NavLink to="/destination-wedding" onClick={closeMenu}>
            <FontAwesomeIcon icon={faRing} /> Destination Wedding
          </NavLink>
        </li>
        <li>
          <NavLink to="/honeymoon" onClick={closeMenu}>
            <FontAwesomeIcon icon={faHeart} /> Honeymoon
          </NavLink>
        </li>
        <li>
          <NavLink to="/activities" onClick={closeMenu}>
            <FontAwesomeIcon icon={faUmbrellaBeach} /> Activity
          </NavLink>
        </li>
        <li>
          <NavLink to="/tour/customtour" onClick={closeMenu}>
            <FontAwesomeIcon icon={faPen} /> Itinerary
          </NavLink>
        </li>
        <li>
          <NavLink to="/gallery" onClick={closeMenu}>
            <FontAwesomeIcon icon={faImages} /> Gallery
          </NavLink>
        </li>
        <li>
          <NavLink to="/franchise" onClick={closeMenu}>
            <FontAwesomeIcon icon={faSuitcaseRolling} /> Franchise
          </NavLink>
        </li>
      </ul>
    </>
  );
}

export default Navber;